import React, { useCallback } from 'react';
import { useProviderHelpersMls } from './ProviderHelpersMls';

const Context = React.createContext();

export const MlsMetricsProvider = ({ children }) => {
    const { data, execute, loginMls, clearData } = useProviderHelpersMls();

    const checkAuth = useCallback(async () => {
        await loginMls();
    }, [loginMls]);
    
    const selectZipMetrics = useCallback(async (props) => {
        await execute({ scope: 'selectzip', url: `metrics/zipcode/${props.zipcode}`, method: 'GET', secure: false });
    }, [execute]);

    const selectListingDetail = useCallback(async (props) => {
        await execute({ scope: 'selectlisting', url: `listing/${props.redName}/${props.listingId}/`, method: 'GET', secure: false });
    }, [execute]);

    const value = { selectZipMetrics, selectListingDetail, checkAuth, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMlsMetricsStore = () => React.useContext(Context);
